import { useParams } from 'react-router-dom'
import PageSectionForm from './PageSectionForm'

const View = () => {
    const params = useParams()

    return (
        <PageSectionForm
            inPopup={false}
            id={parseInt(params.pageSectionId)}
            config={{
                submitSuccessMsg: {
                    header: 'Updated',
                    message: 'Page section updated successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to update page section',
                },
                saveButton: {
                    label: 'Update',
                    savingLabel: 'Updating page section...',
                },
            }}
        />
    )
}

export default View
